import { Card } from '../../../Common/Charts/Card';
import Loading from '../../../Common/Loading';
import { currency } from '../../../Common/Util/currency';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const Indicators = () => {
    const { chartData, isLoading } = useServicesChartsDataContext();

    if (isLoading) return <Loading />;

    const indicators = [
        { key: 'total_val_sh', label: 'Soma de SH' },
        { key: 'total_val_sp', label: 'Soma de SP' },
        { key: 'total_val_sadt', label: 'Soma de SADT' },
        { key: 'total_val_acomp', label: 'Soma de Acompanhamentos' },
        { key: 'total_val_ortp', label: 'Soma de Ortopedia' },
        { key: 'total_val_sangue', label: 'Soma de Sangue' },
        { key: 'total_val_transp', label: 'Soma de Transporte' },
        { key: 'total_val_obsang', label: 'Soma de Observação Sangue' },
        { key: 'total_val_ped1ac', label: 'Soma de Pedidos 1 Acompanhamento' },
        { key: 'total_val_rn', label: 'Soma de RN' },
        { key: 'total_val_tot', label: 'Soma de Totais' },
        { key: 'total_val_uci', label: 'Soma de UCI' },
        { key: 'total_val_uti', label: 'Soma de UTI' },
    ];

    return (
        <div className="d-flex flex-wrap" style={{ gap: '10px' }}>
            {indicators.map(({ key, label }) => (
                <Card
                    key={key}
                    title={label}
                    value={currency.formatToBrCurrency(chartData?.[key] || 0)}
                />
            ))}
        </div>
    );
};